"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.pipeRequest = void 0;

var _react = _interopRequireDefault(require("react"));

var _pipe = require("./pipe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var actions = {
  renderLoader: function renderLoader(options) {
    return function (Loader) {
      options.Loader = Loader;
    };
  },
  mapRequestToProps: function mapRequestToProps(options) {
    return function (mapRequestToProps) {
      options.mapRequestToProps = mapRequestToProps;
    };
  },
  request: function request(options) {
    return function (request) {
      return function (App) {
        return (
          /*#__PURE__*/
          function (_React$Component) {
            _inherits(RenderPipeRequest, _React$Component);

            function RenderPipeRequest(props) {
              var _this;

              _classCallCheck(this, RenderPipeRequest);

              _this = _possibleConstructorReturn(this, _getPrototypeOf(RenderPipeRequest).call(this, props));
              _this.state = {
                isReady: false
              };
              return _this;
            }

            _createClass(RenderPipeRequest, [{
              key: "componentDidMount",
              value: function componentDidMount() {
                var _this2 = this;

                request(this.props).then(function (res) {
                  if (_this2.isUnmount) return;

                  _this2.setState({
                    isReady: true,
                    data: options.mapRequestToProps ? options.mapRequestToProps(res) : null
                  });
                });
              }
            }, {
              key: "componentWillUnmount",
              value: function componentWillUnmount() {
                this.isUnmount = true;
              }
            }, {
              key: "render",
              value: function render() {
                var _this$state = this.state,
                    isReady = _this$state.isReady,
                    data = _this$state.data;
                var FinalApp = App;

                var finalProps = _objectSpread({}, this.props, data);

                var Loader = options.Loader || null;
                return !isReady && Loader ? _react.default.createElement(Loader, finalProps) : _react.default.createElement(FinalApp, finalProps);
              }
            }]);

            return RenderPipeRequest;
          }(_react.default.Component)
        );
      };
    };
  }
};

var pipeRequest = function pipeRequest(externalsActions) {
  return (0, _pipe.pipe)(_objectSpread({}, externalsActions, actions));
};

exports.pipeRequest = pipeRequest;
var _default = {
  pipeRequest: pipeRequest
};
exports.default = _default;